import React from "react";

/**
 * Largura de tela não indica se o dispositivo tem teclado/mouse físico —
 * tablets em paisagem (e modelos maiores mesmo em retrato) passam fácil dos
 * breakpoints "desktop" do MUI sem ter teclado. `pointer: coarse` detecta o
 * mecanismo de entrada primário (dedo vs. mouse/trackpad), então cobre
 * tablet em qualquer orientação sem depender de um número de largura.
 */
export const isCoarsePointerDevice = (): boolean =>
  typeof window !== "undefined" &&
  typeof window.matchMedia === "function" &&
  window.matchMedia("(pointer: coarse)").matches;

/** Versão reativa de isCoarsePointerDevice — atualiza se o mecanismo de
 * entrada mudar (ex.: tablet com mouse/trackpad conectado depois). */
export const useIsCoarsePointerDevice = (): boolean => {
  const [isCoarse, setIsCoarse] = React.useState(isCoarsePointerDevice);

  React.useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
      return;
    }
    const mql = window.matchMedia("(pointer: coarse)");
    const onChange = () => setIsCoarse(mql.matches);
    onChange();

    // Safari < 14 só tem a API legada (addListener/removeListener) — sem
    // esse fallback, o addEventListener abaixo estouraria no useEffect.
    if (typeof mql.addEventListener === "function") {
      mql.addEventListener("change", onChange);
      return () => mql.removeEventListener("change", onChange);
    }
    if (typeof mql.addListener === "function") {
      mql.addListener(onChange);
      return () => mql.removeListener(onChange);
    }
    return undefined;
  }, []);

  return isCoarse;
};
